<template>
  <rest
    :remote="remote"
    :table-columns="tableColumns"
    :form-initialize="formInitialize"
    :form-rules="formRules"
    :exportable="true"
    :export-visible="true"
    :create-able="true" :update-able="true" :delete-able="true"
    :use-drawer="true"
    drawer-width="50%"
  >
    <template slot="formItem-certMd5" slot-scope="{item, form}">
      {{ form[item.prop] }}
    </template>
    <template slot="formItem-certContent" slot-scope="{item, form}">
      <div class="upload-btn-container">
        <FileUpload
          :column="item"
          v-bind:formData="form"
          :hideFile="true"
          :input="{accept: '.pem'}"
          :acceptRegExp="acceptRegExp"
          :uploadUrl="uploadUrl"
        >
          <el-button type="primary" icon="el-icon-upload2" class="btn-upload-cert">上传证书文件</el-button>
        </FileUpload>
      </div>
      <el-input type="textarea" :rows="16" class="cert-textarea" placeholder="请上传 pem 证书文件或直接在此处输入证书内容..." @input="onInput(item, form)" v-model.trim="form[item.value]"></el-input>
    </template>
  </rest>
</template>

<script>
import Rest from '@/components/Spring/Rest'
import FileUpload from '@/components/Widget/FileUpload.vue'
import md5 from 'js-md5'
import utils from '@/common/utils'

export default {
  name: 'pkgConfigs',
  components: { Rest, FileUpload },

  data () {
    return {
      remote: {
        path: 'channel',
        resource: this.$options.name,
        realtime: true,
        createLabel: '新增证书配置'
      },
      formInitialize: {
        certMd5: '',
        certContent: ''
      },
      formRules: {
        name: [{ required: true, trigger: ['submit', 'blur'], message: '请填写证书名称' }],
        appId: [{ required: true, trigger: ['submit', 'blur'], message: '请填写游戏ID' }],
        channelId: [{ required: true, message: '请填写channelId' }],
        expiredDate: [{ required: true, message: '请填写证书过期时间' }],
        adLostRate: [{ required: true, message: '请填写广告回传概率' }],
        certContent: [{ required: true, message: '请填写证书内容' }]
      },
      listeners: {
      },
      channelOptions: []
    }
  },
  computed: {
    tableColumns () {
      return [
        { label: 'ID', prop: 'id', hiddenForm: true, minWidth: 90 },
        { label: '证书名称', prop: 'name', minWidth: 180 },
        { label: '包名', prop: 'pkgName', minWidth: 200 },
        { label: '游戏ID', prop: 'appId', minWidth: 120 },
        { label: '渠道Id', prop: 'channelId', minWidth: 120 },
        { label: '广告回传概率', prop: 'adLostRate', minWidth: 140 },
        { label: '证书md5', prop: 'certMd5', formType: 'slot', showOverflowTooltip: true, minWidth: 220 },
        { label: '证书内容', prop: 'certContent', value: 'certContent', formType: 'slot', tableType: 'extTextPopover', minWidth: 140 },
        { label: '过期时间', prop: 'expiredDate', type: 'datetime', minWidth: 180 },
        { label: '创建时间', prop: 'createdAt', type: 'datetime', hiddenForm: true, minWidth: 180 },
        { label: '修改时间', prop: 'updatedAt', type: 'datetime', hiddenForm: true, minWidth: 180 }
      ]
    },
    acceptRegExp () {
      return /.pem$/
    }
  },
  methods: {
    onInput: utils.debounce((item, form) => {
      const value = form[item.prop]
      form = Object.assign(form, { certMd5: value ? md5(value.trim()) : '' })
      // console.log(value, form)
    }, 300),
    uploadUrl (file, column, formData) {
      console.log(file)
      // 上传时 默认文件名 为包名
      formData.pkgName = file.name.replace(this.acceptRegExp, '').replaceAll('.cert', '')
      const reader = new FileReader()
      reader.readAsText(file, 'UTF-8')
      return new Promise((resolve) => {
        reader.onload = (e) => {
          console.log('解析成功', e)
          formData.certMd5 = md5(e.target.result.trim())
          resolve(e.target.result.trim())
        }
        reader.onerror = () => {
          console.error('解析失败')
          resolve('')
        }
      })
    }
  },
  mounted () {}
}
</script>

<style scoped>
::v-deep.file-upload .upload {
  width: max-content;
  height: max-content;
  border-color: transparent;
  cursor: pointer;
}

.upload-btn-container {
  margin-bottom: 12px;
}

.btn-upload-cert {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  padding: 8px 16px !important;
  font-size: 12px !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.2) !important;
  transition: all 0.2s ease !important;
}

.btn-upload-cert:hover {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
  box-shadow: 0 6px 12px -1px rgba(37, 99, 235, 0.3) !important;
  transform: translateY(-1px);
}

.cert-textarea {
  margin-top: 8px;
}

.cert-textarea :deep(.el-textarea__inner) {
  border-radius: 8px !important;
  border-color: var(--border-color) !important;
  background-color: var(--bg-page) !important;
  color: var(--text-main) !important;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace !important;
  padding: 12px !important;
  transition: all 0.2s ease;
}

.cert-textarea :deep(.el-textarea__inner:focus) {
  border-color: var(--primary-color) !important;
  background-color: var(--bg-card) !important;
}
</style>
